import { render, staticRenderFns } from "./ProCommentList.vue?vue&type=template&id=e43ecede&"
import script from "./ProCommentList.vue?vue&type=script&lang=ts&"
export * from "./ProCommentList.vue?vue&type=script&lang=ts&"
import style0 from "./ProCommentList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports